import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { Locales } from '@core/constants/locales.config';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { BREAK_POINT } from '@shared/enum/breakpoint-enum';
import { TOAST_SEVERITY } from '@shared/enum/toast-severity.enum';
import { Message, PrimeNGConfig } from 'primeng/api';
import { Toast, ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToastModule],
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  providers: [],
})
export class AppComponent implements OnInit {
  smallScreen = 1439;
  isSmallScreen: boolean = false;
  sidebarVisible: boolean = false;
  environment = environment;
  sanitizer = inject(DomSanitizer);
  shopURL?: string;
  iframeUrl: SafeResourceUrl;
  screenWidth: number;
  BREAK_POINT = BREAK_POINT;
  TOAST_SEVERITY = TOAST_SEVERITY;

  @ViewChild('toast') toast: Toast;

  constructor(
    private primeNGConfig: PrimeNGConfig,
    private translate: TranslateService
  ) {
    window.addEventListener('message', this.handleReceiveMessage);
    const lang = this.getLangFromUrl();
    if (lang && Locales.includes(lang.toLowerCase())) {
      this.translate.setDefaultLang(lang);
      localStorage.setItem('lang', lang);
    } else this.translate.setDefaultLang('vi');
  }

  ngOnInit(): void {
    // this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    //   `${environment.ADMIN_HUB_URL}/app-connect`
    // );
    this.screenWidth = window.innerWidth;
    this.primeNGConfig.setTranslation({
      firstDayOfWeek: 1,
    });
  }

  onActivate() {
    window.scroll({
      top: 0,
      left: 0,
    });
  }

  checkSmallScreen() {
    this.isSmallScreen = window.innerWidth <= this.smallScreen;
  }

  isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
    input !== null && input.tagName === 'IFRAME';

  // handleOnLoad = () => {
  //   const frame = document.getElementById('socialLogin');
  //   if (this.isIFrame(frame) && frame.contentWindow) {
  //     frame.contentWindow.postMessage({ type: 'connect' }, '*');
  //   }
  // };

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = (event.target as Window).innerWidth ?? this.screenWidth;
  }

  handleToastItemClick(message: Message) {
    if (message.data?.clickCb) {
      let index = this.toast.messages.findIndex((item) => item === message);
      message.data?.clickCb();
      if (index !== -1) {
        this.toast.messages.splice(index, 1);
      }
    }
  }

  @HostListener('window:message', ['$event'])
  handleReceiveMessage = async (e: MessageEvent) => {
    if (e.origin !== environment.CRM_FE_URL) return;

    const { path, data } = e?.data || {};
    if (path === '/chat-faq-module/send-access-token' && data) {
      localStorage.setItem('accessToken', data);
    }
  };
  // @HostListener('window:message', ['$event'])
  // handleReceiveMessage = async (e: MessageEvent) => {
  //   if (e?.data?.type === 'authorized') {
  //     this.iframeUrl = '';
  //     const accessTokenData = e.data?.token?.accessToken;
  //     const profileData = JSON.parse(e.data?.profile);
  //     if (accessTokenData && profileData) {
  //       localStorage.setItem('accessToken', accessTokenData);
  //       localStorage.setItem('auth', JSON.stringify(profileData));
  //       localStorage.setItem(environment.AUTH_STATUS, JSON.stringify({ isLoggedIn: true }));
  //     } else {
  //       // window.location.href = `${environment.ADMIN_HUB_URL}/login?r=${environment.FE_URL}`; // => COMMENT WHILE DEV
  //     }
  //   }
  // };
  getLangFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('lang');
  }
}
